export default __webpack_public_path__ + "static/media/bag2.c4e2a85e.svg";